// Shared API configuration - runtime domain detection
// Works on sqawk.app (production) and preview environments

export const getBackendUrl = () => {
  if (typeof window === 'undefined') return '';
  
  const hostname = window.location.hostname;
  
  // Production domains - use relative URLs
  if (hostname === 'sqawk.app' || hostname === 'www.sqawk.app') {
    return '';
  }
  
  // Use environment variable for deployed environments, fallback to empty for relative URLs
  return process.env.REACT_APP_BACKEND_URL || '';
};

export const BACKEND_URL = getBackendUrl();

// Helper to get auth headers
export const getAuthHeaders = () => {
  const token = localStorage.getItem('sqawk_session');
  if (token) {
    return { 'Authorization': `Bearer ${token}` };
  }
  return {};
};

export default BACKEND_URL;
